import { render, staticRenderFns } from "./DialogFromAPI.vue?vue&type=template&id=954349e6&scoped=true"
import script from "./DialogFromAPI.vue?vue&type=script&lang=js"
export * from "./DialogFromAPI.vue?vue&type=script&lang=js"
import style0 from "./DialogFromAPI.vue?vue&type=style&index=0&id=954349e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "954349e6",
  null
  
)

export default component.exports